import React, {useState, useEffect } from 'react';
import { Container, Row } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import AllOrders from './AllOrders';
import { useSelector, useDispatch } from "react-redux"; 
import { fetchOrders } from '../../../utils/order';
import { createSelector } from 'reselect';

const OrderList = () => {
    const dispatch = useDispatch();

    const cryptoorderData = createSelector(
        (state) => state.Crypto,
        (orderList) => orderList.orderList
      );
    // Inside your component
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });

  // Handle pagination changes
  const handlePaginationChange = ({ pageIndex, pageSize: newPageSize }) => {
    setCurrentPage(pageIndex);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
  };

  const [orderList, setOrderListData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);
   // const orderList = useSelector(cryptoorderData);
    useEffect(() => {
        const loadOrderListData = async () => {
            try { 
              const response = await fetchOrders(currentPage, pageSize); 
              console.log('Order List API Response:', response); // Debug logging
                
              if(response.success && response.order_data && response.order_data.orders){ 
                console.log('Setting order data:', response.order_data.orders);
                setOrderListData(response.order_data.orders);
                // Set total count from API response or fallback to orders length
                setTotalCount(response.order_data.total || response.order_data.orders.length);
              } else {
                console.error('API Error or no orders:', response);
                errornotify(response.message || 'Failed to load orders')  
              }
            } catch (error) {
              console.error('Exception in loadOrderListData:', error);
              errornotify(error.message) 
            } finally {
              // setLoading(false);
            }
          };
      
          loadOrderListData();
        }, [currentPage, pageSize]);

    document.title = "Orders | SeedNations";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Order List" pageTitle="Order" />
                    <Row>
                    <ToastContainer />
                        <AllOrders 
                            orderList={orderList} 
                            total={totalCount} 
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onChange={handlePaginationChange}
                        />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default OrderList;